module.exports = __webpack_public_path__ + "static/media/logo-android.90adbe1d.svg";